import React from 'react';
import css from './ConversionOverlayTooltipContent.module.scss';
import { ConversionElementStatsDetails } from '../../Components';
import { ConversionOverlayFunnelDetails } from '../../ClickMaps/types';

interface ConversionOverlayTooltipProps {
  conversionEventLabel: string;
  elementStats: ConversionOverlayFunnelDetails | undefined;
}

export const ConversionOverlayTooltipContent: React.FC<ConversionOverlayTooltipProps> = ({
  conversionEventLabel,
  elementStats,
}) => {
  if (!elementStats) {
    return null;
  }

  return (
    <div data-component="ConversionOverlayTooltipContent" className={css.tooltip}>
      <ConversionElementStatsDetails
        elementStats={elementStats}
        conversionEventLabel={conversionEventLabel}
        color="default-inverse"
      />
    </div>
  );
};
